import React from 'react';
import {
  Box,
  Divider,
  Paper,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { Screen } from 'src/components/screen';
import { useTranslation } from 'src/text';
import { BillingProvider } from './billing-context';
import { LocationBillingList } from './components/location-billing-list';
import {
  billingCard,
  contentContainer,
  pageContainer,
  titleRow,
  toggleGroup,
} from './styles';

const BillingScreenInner: React.FC = () => {
  const { billingLabels } = useTranslation();
  const [billingCycle, setBillingCycle] = React.useState<'monthly' | 'yearly'>(
    'monthly',
  );

  return (
    <Box sx={pageContainer}>
      <Box sx={contentContainer}>
        <Paper elevation={0} sx={billingCard}>
          <Stack spacing={2.5}>
            <Stack
              sx={titleRow}
              direction="row"
              justifyContent="space-between"
              alignItems="center">
              <Typography variant="h6">
                {billingLabels.locationsBillingTitle}
              </Typography>
              <ToggleButtonGroup
                exclusive
                size="small"
                color="primary"
                value={billingCycle}
                onChange={(_, val) => val && setBillingCycle(val)}
                sx={toggleGroup}>
                <ToggleButton value="monthly">
                  {billingLabels.billingCycleMonthly}
                </ToggleButton>
                <ToggleButton value="yearly">
                  {billingLabels.billingCycleYearly}
                </ToggleButton>
              </ToggleButtonGroup>
            </Stack>

            <Typography variant="body2" color="text.secondary">
              {billingLabels.locationsBillingSubtitle}
            </Typography>

            <Divider />

            <LocationBillingList billingCycle={billingCycle} />
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
};

const BillingScreen: React.FC = () => (
  <Screen>
    <BillingProvider>
      <BillingScreenInner />
    </BillingProvider>
  </Screen>
);

export { BillingScreen };
